import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'
import { AuthProvider } from '@/providers/auth-provider'
import LoginPage from '@/pages/login'
import DashboardPage from '@/pages/dashboard'
import ProfileSettingsPage from '@/pages/settings/profile'
import HomepageSettingsPage from '@/pages/settings/homepage'
import GalleryPage from '@/pages/gallery'
import ThemeSettingsPage from '@/pages/settings/theme/index'
import ThemaPage from '@/pages/settings/theme/presets'
import PaymentSettingsPage from '@/pages/cheki/payment'
import ChekiSettingPage from '@/pages/cheki/setting'
import NavigationSettingsPage from '@/pages/settings/navigation'
import PagesManagerPage from '@/pages/pages/index'
import PageEditorPage from '@/pages/pages/editor'
import EventsPage from '@/pages/events'
import EventFormPage from '@/pages/events/event-form'
import EventDetailPage from '@/pages/events/event-detail'
import MembersPage from '@/pages/members'
import MemberFormPage from '@/pages/members/member-form'
import MemberDetailPage from '@/pages/members/member-detail'
import MemberChekiPage from '@/pages/members/member-cheki'
import ChekiFormsPage from '@/pages/cheki/index'
import ChekiFormDetailPage from '@/pages/cheki/form-detail'
import ChekiAnalyticsPage from '@/pages/cheki/analytics'
import ChekiTemplatesPage from '@/pages/cheki/templates'
import SubscriptionPage from '@/pages/settings/subscription'
import AccountSettingsPage from '@/pages/settings/account'
import MusicPage from '@/pages/music/index'
import ReleaseDetailPage from '@/pages/music/release-detail'
import ShopPage from '@/pages/shop/index'
import MediaPage from '@/pages/media/index'
import FAQPage from '@/pages/faq/index'
import { Shell } from '@/components/layout/shell'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const session = useAuthStore((s) => s.session)
  if (!session) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Shell />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="settings/homepage" element={<HomepageSettingsPage />} />
            <Route path="settings/profile" element={<ProfileSettingsPage />} />
            <Route path="settings/thema" element={<ThemaPage />} />
            <Route path="settings/theme" element={<ThemeSettingsPage />} />
            <Route path="settings/navigation" element={<NavigationSettingsPage />} />
            <Route path="pages" element={<PagesManagerPage />} />
            <Route path="pages/:slug" element={<PageEditorPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="events/new" element={<EventFormPage />} />
            <Route path="events/:id/edit" element={<EventFormPage />} />
            <Route path="events/:id" element={<EventDetailPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="members/new" element={<MemberFormPage />} />
            <Route path="members/:id/edit" element={<MemberFormPage />} />
            <Route path="members/:id/cheki" element={<MemberChekiPage />} />
            <Route path="members/:id" element={<MemberDetailPage />} />
            <Route path="cheki" element={<ChekiFormsPage />} />
            <Route path="cheki/analytics" element={<ChekiAnalyticsPage />} />
            <Route path="cheki/:formId" element={<ChekiFormDetailPage />} />
            <Route path="cheki/templates" element={<ChekiTemplatesPage />} />
            <Route path="cheki/payment" element={<PaymentSettingsPage />} />
            <Route path="cheki/setting" element={<ChekiSettingPage />} />
            <Route path="settings/subscription" element={<SubscriptionPage />} />
            <Route path="settings/account" element={<AccountSettingsPage />} />
            <Route path="music" element={<MusicPage />} />
            <Route path="music/:releaseId" element={<ReleaseDetailPage />} />
            <Route path="shop" element={<ShopPage />} />
            <Route path="faq" element={<FAQPage />} />
            <Route path="media" element={<MediaPage />} />
            <Route path="media/:folderSlug" element={<MediaPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
